module.exports = __webpack_public_path__ + "img/1534513675.6014efa8.jpg";